/*
 * @Description:
 * @Date: 2025-06-17 11:19:58
 */
import { computed } from 'vue';
import { XrkMessage, useTableColumn } from 'xrk-components';
import { recognition } from '@V/invoice/src/data-source/apis';

export const useRecognition = async fileUrl => {
  // 数据需要的字段
  const ocr = {
    invoiceAmount: null,
    invoiceNo: null,
    invoiceDate: null,
    sellerName: null,
    sellerRegisterNum: null,
    purchaserName: null,
    purchaserRegisterNum: null
  };
  // 识别失败不阻塞调用await 继续执行
  try {
    const {
      data: {
        amountInFiguers,
        invoiceNumConfirm,
        invoiceDate,
        sellerName,
        sellerRegisterNum,
        purchaserName,
        purchaserRegisterNum
      }
    } = await recognition({ paramURL: fileUrl });
    amountInFiguers && (ocr.invoiceAmount = Math.abs(Number(amountInFiguers))); // 可能为负数，一直以正数处理，最终提交时候按类型给负数
    invoiceNumConfirm && (ocr.invoiceNo = invoiceNumConfirm);
    invoiceDate && (ocr.invoiceDate = invoiceDate);
    sellerName && (ocr.sellerName = sellerName);
    sellerRegisterNum && (ocr.sellerRegisterNum = sellerRegisterNum);
    purchaserName && (ocr.purchaserName = purchaserName);
    purchaserRegisterNum && (ocr.purchaserRegisterNum = purchaserRegisterNum);
  } catch (e) {
    console.error('ocr error:', e);
  }
  return ocr;
};
/**
 * @description: 发票列表批量导出，参与者、个体开票记录、平台开票
 * @params {xrkTableRef} 当前table实例
 * @params {ajax} 下载接口
 * @params {options} 额外参数
 */
export const useBatchDownload = (payload: {
  xrkTableRef;
  ajax;
  options?: { passStatus?: Array<number>; args?: Record<string, any> };
}) => {
  const { xrkTableRef, ajax, options } = payload;
  const passStatus = options?.passStatus || [2, 6];
  const args = options?.args || {};
  const selectionRows = computed(() => {
    return xrkTableRef.value.getSelectionRows() || [];
  });
  const selectionField = () => {
    return useTableColumn({
      type: '_selection',
      prop: 'id',
      align: 'center',
      fixed: 'left',
      width: 120,
      selectionDisabled(row) {
        return !passStatus.includes(row.invoiceStatus);
      },
      addSelectionRow: (rowId, row) => {
        if (selectionRows.value.length < 1000) {
          xrkTableRef.value?.addSelectionRow?.(rowId, row);
        }
      }
    });
  };
  const download = async () => {
    if (!selectionRows.value.length) {
      XrkMessage.warning('请选择需要导出的数据');
      return;
    }
    const searchValue = xrkTableRef.value.getSearchValue();
    await ajax({
      invoiceIdList: selectionRows.value.map(item => item.id),
      ...searchValue,
      ...args
    });
    XrkMessage.success('操作成功，请前往下载中心进行下载查看');
  };

  return {
    selectionField,
    download,
    selectionRows
  };
};
